import { Box } from '@mui/material';
import { TEST_IDS } from 'shared';
import { useSelector } from 'react-redux';
import { useFormContext } from 'react-hook-form';
import { QuillInputField } from 'components/form';
import { deskingSelectors } from '../../../../../model';
import { FormSectionHeader } from '../../../../components';
import { DeskingTestIds } from '../../../../../constants';
import { FinanceProgramFormValues, FormSectionProps } from '../../../../../types';

export const NotesToBuyer = ({ sectionName }: FormSectionProps) => {
  const { control, setValue, getValues } = useFormContext<FinanceProgramFormValues>();

  const isSectionOpen = useSelector((state: any) => deskingSelectors.isSectionOpen(state, sectionName));
  const isSectionCollapsed = useSelector((state: any) => deskingSelectors.isSectionCollapsed(state, sectionName));

  return (
    <Box className="section" data-testid={DeskingTestIds.NotesToBuyer}>
      <FormSectionHeader
        name="Notes to Buyer"
        sectionName={sectionName}
        isSectionOpen={isSectionOpen}
        isSectionCollapsed={isSectionCollapsed}
      />

      <Box className="sectionFields">
        <QuillInputField
          control={control}
          setValue={setValue}
          getValues={getValues}
          name="notesToBuyer"
          dataTestId={TEST_IDS.desking.notesToBuyer.notes}
          placeholder="Add notes that will be visible to the buyer..."
        />
      </Box>
    </Box>
  );
};
